<template>
  <div
    class="flex w-full justify-center z-10"
    :class="{ 'absolute bottom-5': display === 'absolute' }">
    <BaseBank text="מפתח צבעים" class="bank-button flex" :display="display">
      <template #default="{ minimized }">
        <div v-if="!minimized" class="flex gap-2 items-center">
          <div class="flex w-full justify-between flex-wrap">
            <div
              v-for="(option, index) in options"
              :key="index"
              class="flex flex-[50%] gap-2 items-center p-2">
              <div
                :style="{ backgroundColor: option.label }"
                class="rounded-full w-3 h-3 min-w-[12px]"/>
              <div>{{ option.text }}</div>
            </div>
          </div>
        </div>
        <div v-else class="flex gap-2 flex-row-reverse">
          <div
            v-for="(option, index) in options"
            :key="index"
            :style="{ backgroundColor: option.label }"
            class="rounded-full w-2 h-2"/>
        </div>
      </template>
    </BaseBank>
  </div>
</template>

<script setup lang="ts">
import { IColorLegend } from '@/types/interfaces';
import BaseBank from '@/components/BaseBank/BaseBank.vue';

enum LegendBankPosition {
  RELATIVE = 'relative',
  ABSOLUTE = 'absolute',
}
interface IProps {
  legendText: string;
  options: IColorLegend[];
  display: LegendBankPosition;
}

withDefaults(defineProps<IProps>(), {
  legendText: 'מפתח צבעים',
  options: () => [],
  display: LegendBankPosition.ABSOLUTE,
});
</script>
